import { request } from '../request'
import { IHttpResponse } from '../types/general'
import { IOrderResponse } from '../types/orders'

export const getStatistics = (): Promise<IHttpResponse<IOrderResponse[]>> => {
  return request.get('/statistics')
}
